import cln from 'classnames';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { FComponent } from 'mytime-common/f-component';
import {
  humanName,
  phone,
  email,
  requireUnless,
  phoneInternational,
} from './form-validators';
import { required } from 'mytime-common/forms/required-validator';
import {
  reformatPhone,
  reformatPhoneInternational,
} from 'mytime-common/forms/reformat-phone';
import _ from 'lodash';
import { translateResource } from '../../data/translated_resource/TranslatedResourceActions'
import './new-client.scss';
import './new-client-form-controls.scss';
import { createFormView } from 'mytime-common/sync-form/form-view';
import { renderFormGroup } from './render-form-group';
import {
  customFieldTypes,
  kioskIfiToCf,
} from './custom-fields/kiosk-ifi-to-cf';
import { getPathData, setPath } from 'mytime-common/arr-path';
import { chain } from 'mytime-common/fs';

import { Redirect } from 'react-router-dom';
import { ActionButton } from '../Themed.js';
import { t } from '../../locales';

const validations = {
  first_name: [required, humanName],
  // last_name: [required, humanName],
  last_name: [humanName],
  mobile_phone: [requireUnless('email'), phone],
  date_of_birth: [],
  email: [requireUnless('mobile_phone'), email],
};

class NewClient extends FComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      showErrors: false,
      ifis: null,
      submitting: false,
      errors: null,
      employees: null,
    };

    this.refreshIfis = this.refreshIfis.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
    this.refreshIfis();
  }

  componentDidUpdate(prevProps) {
    super.componentDidUpdate();

    if (prevProps.appLanguage !== this.props.appLanguage) {
      this.refreshIfis(true);
    } else {
      this.refreshIfis();
    }
  }

  refreshIfis(force = false) {
    const { ifis, employees, translateResource } = this.props;

    let initData = this.props.client;
    ifis.forEach(ifi => {
      if (translateResource) {
        let oldTitle = ifi.custom_field.initialTitle || ifi.custom_field.title
        let oldContent = ifi.custom_field.initialContent || ifi.custom_field.content
        let translatedRes = translateResource('MyClient::CustomField', {
          id: ifi.custom_field.id,
          name: oldTitle,
          content: oldContent,
        })
        ifi.custom_field.initialContent = oldContent
        ifi.custom_field.initialTitle = oldTitle
        ifi.custom_field.title = translatedRes.name
        ifi.custom_field.content = translatedRes.content

        if (ifi.custom_field.custom_field_options) {
          ifi.custom_field.custom_field_options.forEach((cfo) => {
            cfo.old_option_value = cfo.old_option_value || cfo.option_value
            cfo.option_value = translateResource('MyClient::CustomFieldOption', {
              id: cfo.id,
              option_value: cfo.old_option_value
            }).option_value
          })
        }
      }

      const cfType = customFieldTypes[ifi.custom_field.type];
      const initValue = cfType?.getInitData?.({
        country: this.props.location?.country,
      });
      if (initValue) {
        const path = ['custom_field_values', ifi.custom_field_id];

        if (!getPathData(initData, path)) {
          initData = setPath(initData, path, initValue);
        }
      }
    });
    if (initData !== this.props.client) {
      this.props.onChange(initData);
    }

    if (
      force ||
      !this.state.ifis ||
      !this.state.employees ||
      ifis.length !== this.state.ifis.length ||
      employees.length !== this.state.employees.length
    ) {
      this.setState({ ifis, employees });
    }
  }

  render() {
    const {
      client,
      onChange,
      children,
      onChildChange,
      // onSwitchToReturningClientSequence,
      ui,
      mandatoryFields,
      isNewFamilyMember,
      clientVariations,
      isNewClient,
      isServiceAvailableForClient,
      hasServicesForClient,
    } = this.props;
    let { error, showErrors, ifis, submitting, employees } = this.state;

    if (!error && this.props.errors) {
      error = parseCreateClientErrors(
        this.props.errors,
        this.props.client.email,
        this.props.client.mobile_phone
      );

      showErrors = true;
    }

    // set international phone validation
    if (this.props.isInternational) {
      validations.mobile_phone = [requireUnless('email'), phoneInternational];
    }

    const changeClient = newClient => {
      if (error) {
        this.setState({ error: null });
      }
      if (false /* client && client.id */) {
        // Client data is saved, can't change
        return;
      }
      return onChange(newClient);
    };

    let clientIfis = ifis
      ?.filter(ifi => ifi.custom_field.resource_type === 'MyClient::Client')
      ?.filter(
        ifi => ifi.custom_field.type !== 'MyClient::CustomField::AddressField'
      )
      ?.filter(
        ifi =>
          !(
            ifi.custom_field.type === 'MyClient::CustomField::DateOfBirth' &&
            client.original_date_of_birth != null &&
            !ifi.custom_field.ask_every_time
          )
      )
      ?.filter(
        ifi =>
          !(
            ifi.custom_field.type === 'MyClient::CustomField::Gender' &&
            client.original_gender != null &&
            !ifi.custom_field.ask_every_time
          )
      )
      ?.filter(
        ifi =>
          !(
            ifi.custom_field.type ===
              'MyClient::CustomField::TransactionalEmail' &&
            client.original_can_receive_automated_emails != null &&
            !ifi.custom_field.ask_every_time
          )
      )
      ?.filter(
        ifi =>
          !(
            ifi.custom_field.type ===
              'MyClient::CustomField::TransactionalSms' &&
            client.original_can_receive_automated_sms != null &&
            !ifi.custom_field.ask_every_time
          )
      )
      ?.filter(
        ifi =>
          !(
            ifi.custom_field.type === 'MyClient::CustomField::MarketingEmail' &&
            client.original_can_receive_manual_emails != null &&
            !ifi.custom_field.ask_every_time
          )
      )
      ?.filter(
        ifi =>
          !(
            ifi.custom_field.type === 'MyClient::CustomField::MarketingSms' &&
            client.original_can_receive_manual_sms != null &&
            !ifi.custom_field.ask_every_time
          )
      )
      ?.filter(
        ifi =>
          !isServiceAvailableForClient ||
          !hasServicesForClient ||
          !clientVariations ||
          clientVariations.filter(
            cv =>
              cv.clientId === client.id &&
              cv.childId == null &&
              ifi.variations.indexOf(cv.variationId) > -1
          ).length > 0
      )
      ?.filter(
        ifi => ifi.custom_field.type !== "MyClient::CustomField::Icon"
      );

    if (clientIfis != null && client.original_custom_field_values != null) {
      clientIfis = clientIfis.filter(
        ifi =>
          ifi.ask_every_time === true ||
          client.original_custom_field_values[ifi.custom_field_id] == null ||
          client.original_custom_field_values[ifi.custom_field_id] === ''
      );
    }

    if (clientIfis != null) {
      clientIfis = clientIfis.map(ci => ({
        ...ci,
        sort_order: ci.sort_order ? ci.sort_order : 0,
      }));
      clientIfis = _.sortBy(clientIfis, ['intake_form_id', 'sort_order']);
      clientIfis = _.uniqBy(clientIfis, ci => ci.custom_field_id);
    }

    // remove mandatory ask_every_time fields with values on secondary intake form
    if (clientIfis != null && client.original_custom_field_values != null) {
      clientIfis = clientIfis.filter(
        ifi =>
          !(
            mandatoryFields !== true &&
            ifi.mandatory === true &&
            client.original_custom_field_values[ifi.custom_field_id] != null &&
            client.original_custom_field_values[ifi.custom_field_id] !== ''
          )
      );
    }

    const customInputFields = clientIfis?.map(
      kioskIfiToCf({ showErrors, employees, ui, isInternational: this.props.isInternational })
    );

    const fv = createFormView(client, changeClient, [
      validations,
      customInputFields?.map(({ path, validators }) => ({
        path,
        validators,
      })) || [],
      ...(!customInputFields
        ? []
        : chain(
            customInputFields.filter(({ subValidators }) => subValidators),
            cfs =>
              cfs.map(({ path, subValidators }) =>
                subValidators.map(subValidator => ({
                  path: [...path, subValidator.path],
                  validators: [
                    {
                      name: 'sub',
                      validate: (value, data) =>
                        subValidator.validate(value, getPathData(data, path)),
                    },
                  ],
                }))
              )
          )),
    ]);

    // child form

    const childFvs = [];

    for (let childIndex = 0; childIndex < children.length; childIndex++) {
      let changeChild = null;
      let childIfis = null;
      let childCustomInputFields = null;
      let fvChild = null;

      const child = children[childIndex];

      if (this.props.hasChildren) {
        changeChild = newChild => {
          if (error) {
            this.setState({ error: null });
          }
          if (false /* child && child.id */) {
            // Client data is saved, can't change
            return;
          }
          return onChildChange(newChild, childIndex);
        };

        childIfis = ifis
          ?.filter(ifi => ifi.custom_field.resource_type === 'MyClient::Child')
          ?.filter(
            ifi =>
              ifi.custom_field.type !== 'MyClient::CustomField::AddressField'
          )
          ?.filter(
            ifi =>
              !clientVariations ||
              clientVariations.filter(
                cv =>
                  cv.clientId === client.id &&
                  cv.childId === children[childIndex].id &&
                  ifi.variations.indexOf(cv.variationId) > -1
              ).length > 0
          )
          ?.filter(
            ifi => ifi.custom_field.type !== "MyClient::CustomField::Icon"
          );

        if (childIfis != null) {
          childIfis = childIfis.map(ci => ({
            ...ci,
            sort_order: ci.sort_order ? ci.sort_order : 0,
          }));
          childIfis = _.sortBy(childIfis, ['intake_form_id', 'sort_order']);
          childIfis = _.uniqBy(childIfis, ci => ci.custom_field_id);
        }

        if (childIfis != null && child.original_custom_field_values != null) {
          childIfis = childIfis.filter(
            ifi =>
              ifi.ask_every_time === true ||
              child.original_custom_field_values[ifi.custom_field_id] == null ||
              child.original_custom_field_values[ifi.custom_field_id] === ''
          );
        }

        childCustomInputFields = childIfis?.map(
          kioskIfiToCf({ showErrors, employees, ui, isInternational: this.props.isInternational })
        );

        const childValidations = { firstName: validations.firstName };

        fvChild = createFormView(child, changeChild, [
          childValidations,
          childCustomInputFields?.map(({ path, validators }) => ({
            path,
            validators,
          })) || [],
          ...(!childCustomInputFields
            ? []
            : chain(
                childCustomInputFields.filter(
                  ({ subValidators }) => subValidators
                ),
                cfs =>
                  cfs.map(({ path, subValidators }) =>
                    subValidators.map(subValidator => ({
                      path: [...path, subValidator.path],
                      validators: [
                        {
                          name: 'sub',
                          validate: (value, data) =>
                            subValidator.validate(
                              value,
                              getPathData(data, path)
                            ),
                        },
                      ],
                    }))
                  )
              )),
        ]);
      }

      if (childIfis && childIfis.length > 0) {
        childFvs.push({
          fvChild,
          child,
          childIfis,
          childCustomInputFields,
        });
      }
    }

    const isValidForm = () => {
      if (
        !isNewFamilyMember &&
        (isNewClient || (clientIfis && clientIfis.length > 0))
      ) {
        if (!fv.isValid()) return false;
      }

      if (childFvs && childFvs.length > 0) {
        for (let i = 0; i < childFvs.length; i++) {
          if (!childFvs[i].fvChild.isValid()) return false;
        }
      }

      return true;
    };

    let hasFields = false;
    if (mandatoryFields) hasFields = true;
    if (customInputFields?.length > 0) hasFields = true;

    if (this.props.hasChildren && childFvs) {
      for (let i = 0; i < childFvs.length; i++) {
        if (childFvs[i].childIfis.length > 0) hasFields = true;
      }
    }

    if (!hasFields && this.state.ifis) {
      if (this.props.employeeSelection) {
        return <Redirect to="/staffSelection" />;
      } else {
        return <Redirect to="/summary" />;
      }
    }

    return (
      <div className="new-client">
        {!isNewFamilyMember &&
          (isNewClient || (clientIfis && clientIfis.length > 0)) && (
            <div className="title">
              {client.first_name && !isNewClient
                ? `${t('new_client.please_enter_information_for')} ${
                    client.first_name
                  }`
                : t('new_client.please_enter_your_information')}
            </div>
          )}
        <div className="form" style={{ maxWidth: '100%' }}>
          {!isNewFamilyMember &&
            (isNewClient || (clientIfis && clientIfis.length > 0)) && (
              <React.Fragment>
                {mandatoryFields && (
                  <React.Fragment>
                    <div className="name-row form-row">
                      <div className="col">
                        {fv.withControl(
                          'first_name',
                          renderFormGroup(
                            t('new_client.first_name'),
                            showErrors,
                            ({ bind }) => (
                              <input
                                autoComplete="off"
                                placeholder={t('new_client.john')}
                                {...bind()}
                                disabled={false /* client && client.id */}
                              />
                            )
                          )
                        )}
                      </div>
                      <div className="col">
                        {fv.withControl(
                          'last_name',
                          renderFormGroup(
                            t('new_client.last_name'),
                            showErrors,
                            ({ bind }) => (
                              <input
                                autoComplete="off"
                                placeholder={t('new_client.smith')}
                                {...bind()}
                                disabled={false /* client && client.id */}
                              />
                            )
                          )
                        )}
                      </div>
                    </div>
                  </React.Fragment>
                )}

                {(mandatoryFields ||
                  (this.props.phoneMandatory &&
                    (this.props.client.original_mobile_phone || '') === '')) && (
                  <React.Fragment>
                    <div className="phone-row form-row">
                      {fv.withControl(
                        'mobile_phone',
                        renderFormGroup(
                          t('new_client.phone_number'),
                          showErrors,
                          ({ bind }) => {
                            if (this.props.isInternational) {
                              return (
                                <input
                                  autoComplete="off"
                                  placeholder="(555) 555 5555"
                                  {...reformatPhoneInternational}
                                  type="tel"
                                  {...bind()}
                                  disabled={false /* client && client.id */}
                                />
                              );
                            }

                            return (
                              <input
                                autoComplete="off"
                                placeholder="(555) 555 5555"
                                {...reformatPhone}
                                type="tel"
                                {...bind()}
                                disabled={false /* client && client.id */}
                              />
                            );
                          },
                          true
                        )
                      )}
                    </div>
                  </React.Fragment>
                )}

                {(mandatoryFields ||
                  (this.props.emailMandatory &&
                    (this.props.client.original_email || '') === '')) && (
                  <React.Fragment>
                    <div className="email-row form-row">
                      {fv.withControl(
                        'email',
                        renderFormGroup(
                          t('new_client.email'),
                          showErrors,
                          ({ bind }) => (
                            <input
                              autoComplete="off"
                              placeholder={t('new_client.example_domain_email')}
                              type="email"
                              {...bind()}
                              disabled={false /* client && client.id */}
                            />
                          ),
                          true
                        )
                      )}
                    </div>
                  </React.Fragment>
                )}

                {ifis == null && (
                  <div className="loading-panel">
                    <i className="fas fa-spinner fa-pulse" />
                  </div>
                )}

                {customInputFields?.map(({ render, path }) =>
                  render(fv.scope(path), false /* client && client.id */)
                )}
              </React.Fragment>
            )}

          {this.props.hasChildren &&
            childFvs.map((cfv, i) => (
              <Fragment key={i}>
                <div className="title">
                  {client.first_name && !isNewClient && !isNewFamilyMember
                    ? `${t('new_client.please_enter_information_for')} ${
                        cfv.child.first_name
                      }`
                    : isNewFamilyMember
                    ? `${t('new_client.add_new')} ${
                        this.props.familyMemberTerm
                      }`
                    : `${t('new_client.add')} ${
                        this.props.familyMemberTerm
                      } ${t('new_client.information')}`}
                </div>

                {cfv.childIfis &&
                  cfv.childIfis.length > 0 &&
                  cfv.childCustomInputFields?.map(({ render, path }) =>
                    render(
                      cfv.fvChild.scope(path),
                      false /* child && child.id */
                    )
                  )}
              </Fragment>
            ))}

          {error && renderError(error)}

          {error && error.type === 'client-exists' ? (
            <ActionButton
              // onClick={() =>
              //   onSwitchToReturningClientSequence(
              //     error.email || error.mobile_phone
              //   )
              // }
              style={ui.buttonStyle}
            >
              {t('new_client.start_over')}
            </ActionButton>
          ) : (
            <ActionButton
              className={cln({ disabled: !isValidForm() })}
              onClick={() => {
                !isValidForm()
                  ? this.showErrors(fv.getErrorDomQuery())
                  : this.submit();
              }}
              disabled={submitting}
              style={
                submitting || !isValidForm()
                  ? ui.buttonStyleDisabled
                  : ui.buttonStyle
              }
            >
              {t('new_client.continue')}
              {submitting && (
                <Fragment>
                  {' '}
                  <i className="fas fa-spinner fa-pulse" />
                </Fragment>
              )}
            </ActionButton>
          )}
        </div>
      </div>
    );
  }

  submit() {
    this.setState({ submitting: true });
    this.props.onComplete().then(() => this.setState({ submitting: false }));
  }

  showErrors(errorDomQuery) {
    const { showErrors } = this.state;
    if (!showErrors) {
      this.setState({ showErrors: true });
    }

    const dom = ReactDOM.findDOMNode(this).querySelector(errorDomQuery);
    if (!dom) {
      return;
    }
    if (dom.nodeName === 'INPUT') {
      dom.focus();
    } else {
      dom.scrollIntoView();
    }
  }
}

const renderError = error =>
  error.type === 'unknown' ? (
    <div className="error">
      {t('new_client.unknown_error_creating')}{' '}
      {error.phase === 'create-client' ? 'client' : 'appointment'}{' '}
      {t('new_client.data')}
    </div>
  ) : error.type === 'client-exists' ? (
    <div className="error">
      {t(
        'new_client.this_client_is_already_registered_please_start_again_with_returning'
      )}
      <br />
      {t('new_client.client_option')}
    </div>
  ) : (
    <div className="error">
      {error.messages.map((msg, i) => (
        <div key={i}>{msg}</div>
      ))}
    </div>
  );

const parseCreateClientErrors = (errors, email, mobile_phone) => {
  if (
    errors.general &&
    errors.general[0] === t('new_client.this_client_already_exists')
  ) {
    return {
      type: 'client-exists',
      email,
      mobile_phone,
    };
  } else {
    return {
      phase: 'create-client',
      messages: Object.keys(errors).map(
        key => `${key}: ${errors[key].join(', ')}`
      ),
    };
  }
};

export default connect(
  () => { return {} },
  { translateResource },
)(NewClient);